import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createSuper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import BaseMap from './BaseMap';
import { CoordinateTransformer } from './CoordinateTransformer';
import MapLoader from './MapLoader';
var TDTMapEngine = /*#__PURE__*/function (_BaseMap) {
  _inherits(TDTMapEngine, _BaseMap);
  var _super = _createSuper(TDTMapEngine);
  function TDTMapEngine() {
    _classCallCheck(this, TDTMapEngine);
    return _super.apply(this, arguments);
  }
  _createClass(TDTMapEngine, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var center;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return MapLoader.load('tianditu');
              case 2:
                this.map = new window.T.Map(this.containerId, {
                  projection: 'EPSG:900913'
                });
                center = (options === null || options === void 0 ? void 0 : options.center) || [118.180987, 24.486432];
                this.map.centerAndZoom(this.createLngLatInstance.apply(this, _toConsumableArray(center)), (options === null || options === void 0 ? void 0 : options.zoom) || 10);
                if (options !== null && options !== void 0 && options.zoomEnable) {
                  this.map.enableScrollWheelZoom();
                } else {
                  this.map.disableScrollWheelZoom();
                }
                return _context.abrupt("return", this.map);
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "panTo",
    value: function panTo(position) {
      this.map.panTo(this.createLngLatInstance.apply(this, _toConsumableArray(position)));
      this.map.checkResize();
      return this;
    }
  }, {
    key: "clearInfoWindow",
    value: function clearInfoWindow() {
      this.map.closeInfoWindow();
      return this;
    }
  }, {
    key: "clearMap",
    value: function clearMap() {
      this.map.clearOverLays();
      return this;
    }
  }, {
    key: "removeOverLay",
    value: function removeOverLay(options) {
      this.map.removeOverLay(options);
      return this;
    }
  }, {
    key: "addOverLay",
    value: function addOverLay(marker) {
      this.map.addOverLay(marker);
      return this;
    }
    // 辅助方法：将天地图返回结果格式化为高德POI格式（保持原有逻辑兼容）
  }, {
    key: "formatTiandituResult",
    value: function formatTiandituResult(tdtResult) {
      if (!tdtResult) return [];
      // 天地图地理编码返回的核心字段映射到高德POI格式
      return [{
        location: {
          lng: tdtResult.location.lng,
          lat: tdtResult.location.lat
        },
        address: tdtResult.address || '',
        name: tdtResult.name || this.searchKey,
        // 搜索关键词作为名称
        adcode: tdtResult.adcode || '',
        // 行政区编码
        province: tdtResult.province || '',
        // 省份
        city: tdtResult.city || '',
        // 城市
        district: tdtResult.district || '',
        // 区县
        township: tdtResult.township || '',
        // 乡镇
        street: tdtResult.street || '',
        // 街道
        streetNumber: tdtResult.streetNumber || '' // 门牌号
      }];
    }
  }, {
    key: "createPlaceSearch",
    value: function createPlaceSearch(options) {
      var _this = this;
      var place = new window.T.LocalSearch(this.map.map);
      place.search = function (keyword, func) {
        return place.getLocation(keyword, function (result) {
          console.log('AutoConsole ~ TDTMapEngine ~ createPlaceSearch ~ result:', result);
          if (result && result.location) {
            // 适配高德格式的结果
            func('complete', {
              info: 'OK',
              poiList: {
                pois: _this.formatTiandituResult(result)
              }
            });
          }
        }, function (error) {
          func('fail');
          // 搜索失败处理
          console.error('天地图搜索失败：', error);
        });
      };
      return place;
    }
  }, {
    key: "reverseAddressFromLngLat",
    value: function reverseAddressFromLngLat(lng, lat) {
      var _this2 = this;
      return new Promise(function (resolve) {
        var geocoder = new window.T.Geocoder();
        geocoder.getLocation(_this2.createLngLatInstance(lng, lat), function (res) {
          resolve(res ? res.getAddress() : '');
        });
      });
    }
  }, {
    key: "createGeolocation",
    value: function createGeolocation(options) {
      var geocoder = new window.T.Geolocation();
      geocoder.getCurrentPositionFix = function (callback) {
        geocoder.getCurrentPosition(function (e) {
          var status = e.lnglat ? 'complete' : 'error';
          if (e.lnglat) {
            var gc02 = CoordinateTransformer.toGCJ02([e.lnglat.lng, e.lnglat.lat]);
            var result = {
              position: {
                lat: gc02[1],
                lng: gc02[0],
                getLat: function getLat() {
                  return gc02[1];
                },
                getLng: function getLng() {
                  return gc02[0];
                }
              },
              formattedAddress: ''
            };
            callback(status, result);
          } else {
            callback(status, {});
          }
        }, options);
      };
      return geocoder;
    }
  }, {
    key: "createGeocoder",
    value: function createGeocoder() {
      var _this3 = this;
      var geocoder = new window.T.Geocoder();
      geocoder.getAddress = function (center, callback) {
        geocoder.getLocation(_this3.createLngLatInstance.apply(_this3, _toConsumableArray(center)), function (res) {
          var status = res.getStatus() == 0 ? 'complete' : 'error';
          var result = {
            info: 'OK',
            regeocode: {
              formattedAddress: res.getAddress()
            }
          };
          callback(status, result);
        });
      };
      return geocoder;
    }
  }, {
    key: "createMarker",
    value: function createMarker(options) {
      var _this4 = this;
      var position = options.position || [];
      var marker = new window.T.Marker(this.createLngLatInstance.apply(this, _toConsumableArray(position)));
      marker.extData = options.extData; // 手动挂载数据

      if (options.map) {
        this.addOverLay(marker);
      }
      marker.setPosition = function (lnglat) {
        marker.setLngLat(_this4.createLngLatInstance.apply(_this4, _toConsumableArray(lnglat)));
      };
      marker.getPosition = function () {
        return position;
      };
      return marker;
    }
  }, {
    key: "createLngLatInstance",
    value: function createLngLatInstance(lng, lat) {
      // 🔥 核心：不管你坐标哪来的，统一转成天地图可用坐标
      var _CoordinateTransforme = CoordinateTransformer.toWGS84([lng, lat]),
        _CoordinateTransforme2 = _slicedToArray(_CoordinateTransforme, 2),
        wgs84Lng = _CoordinateTransforme2[0],
        wgs84Lat = _CoordinateTransforme2[1];
      return new window.T.LngLat(wgs84Lng, wgs84Lat);
    }
  }, {
    key: "createInfoWindow",
    value: function createInfoWindow(options) {
      var _this5 = this;
      var infoWindow = new window.T.InfoWindow(options.content);
      infoWindow.open = function (_, center) {
        var overlays = _this5.map.getOverlays();
        overlays.forEach(function (overlay) {
          if (overlay.getType() === 3) {
            _this5.map.removeOverLay(overlay); // 移除已打开的信息窗()
          }
        });
        infoWindow.setLngLat(_this5.createLngLatInstance.apply(_this5, _toConsumableArray(center)));
        _this5.map.addOverLay(infoWindow);
      };
      infoWindow.close = function () {
        _this5.map.removeOverLay(infoWindow);
      };
      return infoWindow;
    }
  }, {
    key: "createPixel",
    value: function createPixel(x, y) {
      return new window.T.Point(x, y);
    }
  }, {
    key: "createIcon",
    value: function createIcon(options) {
      return new window.T.Icon({
        iconUrl: options.image,
        iconSize: options.imageSize
      });
    }
  }, {
    key: "createSize",
    value: function createSize(x, y) {
      return new window.T.Point(x, y);
    }
  }, {
    key: "openInfoWindow",
    value: function openInfoWindow(marker, infoWindow) {
      marker.openInfoWindow(infoWindow);
    }
  }, {
    key: "createPolygon",
    value: function createPolygon(options) {
      return new window.T.Polygon(options);
    }
  }, {
    key: "setFitView",
    value: function setFitView() {
      this.map.setViewport();
      return this;
    }
  }, {
    key: "creaeteDistrictSearch",
    value: function creaeteDistrictSearch() {
      var _this6 = this;
      var districtSearch = new window.T.AdministrativeDivision();
      var _search = districtSearch.search;
      districtSearch.search = function (adcode, func) {
        var options = {
          searchType: 1,
          needSubInfo: true,
          needAll: true,
          needPolygon: true,
          needPre: false,
          searchWord: adcode
        };
        _search(options, function (result) {
          func('complete', {
            info: 'OK',
            districtList: {
              districts: _this6.formatTiandituResult(result)
            }
          });
        });
      };
      return districtSearch;
    }
  }, {
    key: "on",
    value: function on(target, eventName, handler) {
      var wrappedHandler = function wrappedHandler(e) {
        // 统一点击事件的坐标返回格式为火星坐标
        // const point = this.map.containerPointToLngLat(e)
        // const lnglat = this.map.containerPointToLngLat(e.containerPoint)

        var gc02 = CoordinateTransformer.toGCJ02([e.lnglat.lng, e.lnglat.lat]);
        e.lnglat.lng = gc02[0];
        e.lnglat.lat = gc02[1];
        e.lnglat.getLng = function () {
          return gc02[0];
        };
        e.lnglat.getLat = function () {
          return gc02[1];
        };
        handler(e);
      };
      if (target && target.addEventListener) {
        target.addEventListener(eventName, wrappedHandler);
        // 存储引用以便后续解绑
        this._eventMap.set(handler, wrappedHandler);
      }
    }
  }, {
    key: "off",
    value: function off(target, eventName, handler) {
      var wrapped = this._eventMap.get(handler);
      if (wrapped) {
        target.removeEventListener(eventName, wrapped);
        this._eventMap.delete(handler);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
    }
  }]);
  return TDTMapEngine;
}(BaseMap);
export { TDTMapEngine as default };